<template>
  <section class="wz-login-wrapper">
    <div class="content">
      <v-card flat class="wz-login-card">
        <v-img src="https://d3lvhibcld6i8v.cloudfront.net/images/whizeo_white_background.png"/>
        <v-form v-model="valid">
          <v-container>
            <v-text-field
                v-model="username"
                :rules="usernameRules"
                label="Username"
                required
                outlined
                dense
            />

            <v-text-field
                outlined
                dense
                v-model="password"
                :rules="passwordRules"
                label="Password"
                required
                :type="showPwd ? 'text' : 'password'"
                :append-icon="showPwd ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPwd = !showPwd"
                @keyup.enter="login()"
            />

            <v-btn
                :loading="loggingIn"
                :disabled="!valid"
                dense
                color="primary"
                block
                @click.stop="login()">
              {{ $wz_locale.login.loginButton }}
            </v-btn>
            <span class="overline txt-invalid-login" v-show="invalidLogin">
              username or password is invalid!
            </span>
          </v-container>
        </v-form>
      </v-card>
    </div>
  </section>
</template>
<script>
import {mapActions, mapState} from "vuex";

export default {
  data: () => ({
    valid: false,
    username: "",
    password: "",
    usernameRules: [(v) => !!v || "Username is required"],
    passwordRules: [(v) => !!v || "Password is required"],
    loggingIn: false,
    invalidLogin: false,
    showPwd: false,
  }),
  computed: {
    ...mapState("authStore", ["authorised"]),
  },
  methods: {
    ...mapActions("authStore", ["AUTH_LOGIN"]),
    async login() {
      this.loggingIn = true;
      await this.AUTH_LOGIN({
        username: this.username,
        password: this.password,
      });

      if (this.authorised) {
        this.loggingIn = false;
        this.$router.push("/");
      } else {
        this.invalidLogin = true;
        this.loggingIn = false;
      }
    },
  },
};
</script>
<style>
.wz-login-wrapper {
  height: 100%;
}

.wz-login-card {
  min-width: 500px;
  min-height: 400px;
}

.content {
  position: absolute;
  left: 50%;
  top: 25%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.txt-invalid-login {
  color: red;
  align-self: center;
}
</style>
